import {
    InfoMailTipExtraLargeAudience,
    InfoMailTipLargeAudience,
} from './getLargeAudienceMailtipInfoText.locstring.json';
import { ApproximateNumberCountText } from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import type { RecipientMailtipInfoWithMembersCount } from '../components/LargeAudienceDetails';

const getLargeAudienceMailtipInfoText = (
    approximateMemberLimit: number,
    recipientsInfo: RecipientMailtipInfoWithMembersCount[],
    extraLargeMemberLimit: number
): string => {
    const { totalNumberCount, isMemberCountApproximate } = recipientsInfo.reduce(
        (acc, recipientInfo) => ({
            totalNumberCount: acc.totalNumberCount + recipientInfo.totalMemberCount,
            isMemberCountApproximate:
                acc.isMemberCountApproximate ||
                recipientInfo.totalMemberCount >= approximateMemberLimit,
        }),
        { totalNumberCount: 0, isMemberCountApproximate: false }
    );

    if (totalNumberCount >= extraLargeMemberLimit) {
        return format(loc(InfoMailTipExtraLargeAudience), extraLargeMemberLimit);
    }

    const memberCountText: string = isMemberCountApproximate
        ? format(loc(ApproximateNumberCountText), totalNumberCount)
        : totalNumberCount.toString();

    return format(loc(InfoMailTipLargeAudience), memberCountText);
};

export default getLargeAudienceMailtipInfoText;
